import React from 'react';
import certificationImage from '../About/certificate.png'

const services = [
    { icon: '🏥', text: 'Medical appointment booking and healthcare coordination' },
    { icon: '🌍', text: 'International job placement for doctors, nurses, and healthcare staff' },
    { icon: '🎓', text: 'Career counseling and profile assessment' },
    { icon: '📋', text: 'Licensing and exam guidance (USA, Germany, U.K., Australia, etc.)' },
    { icon: '✈️', text: 'Visa and immigration assistance' },
    { icon: '🤝', text: 'Pre-departure and post-placement support' },
];

const About = () => {
    return (
        <div style={{ fontFamily: "'Poppins', 'Segoe UI', sans-serif", background: '#f5f8ff' }}>

            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');
                * { box-sizing: border-box; }

                .about-hero {
                    background: linear-gradient(135deg, #0f2050 0%, #1a6b7c 100%);
                    padding: 36px 40px 32px;
                    text-align: center;
                }
                .about-hero .eyebrow {
                    font-family: 'Poppins', sans-serif;
                    font-size: 11px;
                    letter-spacing: 3px;
                    text-transform: uppercase;
                    color: #7ecfdb;
                    margin-bottom: 10px;
                    font-weight: 500;
                }
                .about-hero h1 {
                    font-family: 'Poppins', sans-serif;
                    font-size: clamp(22px, 3vw, 32px);
                    font-weight: 700;
                    margin: 0 0 12px;
                    line-height: 1.2;
                    letter-spacing: -0.5px;
                    color: #ffffff;
                    text-shadow: 0 2px 12px rgba(0,0,0,0.3);
                }
                .about-hero p {
                    font-family: 'Poppins', sans-serif;
                    font-size: 14px;
                    color: #d0eef3;
                    max-width: 560px;
                    margin: 0 auto;
                    line-height: 1.7;
                    font-weight: 300;
                }

                .section-wrap {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 56px 32px 0;
                }

                .card {
                    background: white;
                    border-radius: 16px;
                    padding: 44px 48px;
                    box-shadow: 0 4px 28px rgba(26,45,103,0.07);
                }
                .card h2 {
                    font-family: 'Poppins', sans-serif;
                    font-size: 22px;
                    font-weight: 700;
                    color: #1a2d67;
                    margin-top: 0;
                    margin-bottom: 20px;
                    border-left: 5px solid #1a8a9a;
                    padding-left: 16px;
                }
                .card p {
                    font-family: 'Poppins', sans-serif;
                    font-size: 16px;
                    color: #44546a;
                    line-height: 1.9;
                    margin-bottom: 16px;
                    font-weight: 400;
                }
                .card p:last-child { margin-bottom: 0; }

                .section-title {
                    text-align: center;
                    font-family: 'Poppins', sans-serif;
                    font-size: 26px;
                    font-weight: 700;
                    color: #1a2d67;
                    margin-bottom: 8px;
                }
                .section-sub {
                    text-align: center;
                    font-family: 'Poppins', sans-serif;
                    font-size: 15px;
                    color: #7a8fa6;
                    margin-bottom: 32px;
                    font-weight: 400;
                }

                .services-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
                    gap: 16px;
                }
                .service-card {
                    background: white;
                    border-radius: 14px;
                    padding: 22px 24px;
                    display: flex;
                    align-items: flex-start;
                    gap: 16px;
                    box-shadow: 0 2px 14px rgba(26,45,103,0.06);
                    border-top: 3px solid #1a8a9a;
                    transition: transform 0.2s ease, box-shadow 0.2s ease;
                }
                .service-card:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 8px 24px rgba(26,45,103,0.13);
                }
                .service-card .svc-icon { font-size: 24px; flex-shrink: 0; margin-top: 2px; }
                .service-card .svc-text {
                    margin: 0;
                    font-family: 'Poppins', sans-serif;
                    font-size: 15px;
                    color: #44546a;
                    line-height: 1.65;
                    font-weight: 400;
                }

                .vm-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
                    gap: 24px;
                }
                .vm-card {
                    border-radius: 18px;
                    padding: 40px 36px;
                }
                .vm-card .vm-icon { font-size: 38px; margin-bottom: 16px; }
                .vm-card h3 {
                    font-family: 'Poppins', sans-serif;
                    font-size: 20px;
                    font-weight: 700;
                    margin: 0 0 12px;
                    color: white;
                }
                .vm-card p {
                    font-family: 'Poppins', sans-serif;
                    font-size: 15px;
                    line-height: 1.8;
                    margin: 0;
                    color: rgba(255,255,255,0.9);
                    font-weight: 300;
                }

                .cert-box {
                    background: white;
                    border-radius: 18px;
                    overflow: hidden;
                    box-shadow: 0 6px 32px rgba(26,45,103,0.10);
                    border: 1px solid #e4eaf5;
                }
                .cert-img {
                    width: 100%;
                    max-height: 560px;
                    object-fit: contain;
                    display: block;
                    padding: 32px;
                }
                .cert-footer-bar {
                    padding: 18px 24px;
                    background: linear-gradient(90deg, #0f2050, #1a6b7c);
                    color: white;
                    text-align: center;
                    font-family: 'Poppins', sans-serif;
                    font-size: 14px;
                    font-weight: 500;
                    letter-spacing: 0.5px;
                }
                .cert-placeholder {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    padding: 80px 24px;
                    color: #94a3b8;
                    font-family: 'Poppins', sans-serif;
                }
                .cert-label {
                    display: inline-block;
                    background: #e0f4f6;
                    color: #1a8a9a;
                    font-size: 11px;
                    font-weight: 600;
                    letter-spacing: 2px;
                    text-transform: uppercase;
                    padding: 5px 14px;
                    border-radius: 30px;
                    margin-bottom: 12px;
                    font-family: 'Poppins', sans-serif;
                }

                @media (max-width: 768px) {
                    .card { padding: 28px 20px; }
                    .about-hero { padding: 28px 20px 24px; }
                    .vm-card { padding: 30px 24px; }
                    .section-wrap { padding: 40px 16px 0; }
                    .card h2 { font-size: 18px; }
                    .card p { font-size: 14px; }
                }
            `}</style>

            {/* Hero */}
            <div className="about-hero">
                <p className="eyebrow">Who We Are</p>
                <h1>Medical & International<br />Career Services</h1>
                <p>
                    Empowering healthcare professionals with seamless medical services
                    and global career opportunities — all under one trusted platform.
                </p>
            </div>

            {/* Introduction */}
            <div className="section-wrap">
                <div className="card">
                    <h2>About Our Organization</h2>
                    <p>
                        We are a dynamic and forward-thinking organization specializing in healthcare services and
                        international career opportunities for medical professionals. Our company is committed to
                        empowering individuals in the healthcare sector by providing comprehensive support in both
                        medical services and global career advancement.
                    </p>
                    <p>
                        In the healthcare domain, we offer reliable and efficient solutions such as medical appointment
                        booking, hospital coordination, and patient support services. Our goal is to ensure seamless
                        access to quality healthcare through technology-driven and patient-centric approaches.
                    </p>
                    <p>
                        We proudly specialize in <strong style={{ color: '#1a2d67' }}>International Career Services for Medical Professionals</strong> — assisting
                        doctors, nurses, and allied healthcare professionals in exploring and securing rewarding career
                        opportunities abroad. From career counseling and documentation to licensing guidance and
                        placement support, we provide end-to-end assistance for a smooth transition into international
                        healthcare systems.
                    </p>
                </div>
            </div>

            {/* Key Services */}
            <div className="section-wrap">
                <h2 className="section-title">Our Key Services</h2>
                <p className="section-sub">Comprehensive support from healthcare access to global career placement</p>
                <div className="services-grid">
                    {services.map((s, i) => (
                        <div className="service-card" key={i}>
                            <span className="svc-icon">{s.icon}</span>
                            <p className="svc-text">{s.text}</p>
                        </div>
                    ))}
                </div>
            </div>

            {/* Vision & Mission */}
            <div className="section-wrap">
                <div className="vm-grid">
                    <div className="vm-card" style={{ background: 'linear-gradient(135deg, #0f2050, #1a4080)' }}>
                        <div className="vm-icon">🔭</div>
                        <h3>Our Vision</h3>
                        <p>
                            To become a leading global platform connecting healthcare services with
                            international career pathways for medical professionals worldwide.
                        </p>
                    </div>
                    <div className="vm-card" style={{ background: 'linear-gradient(135deg, #1a6b7c, #1a9aad)' }}>
                        <div className="vm-icon">🎯</div>
                        <h3>Our Mission</h3>
                        <p>
                            To simplify healthcare access and empower medical professionals to achieve
                            successful international careers with integrity and personalized service.
                        </p>
                    </div>
                </div>
            </div>

            {/* Why Choose Us */}
            <div className="section-wrap">
                <div className="card" style={{ textAlign: 'center' }}>
                    <p style={{
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: '11px',
                        letterSpacing: '3px',
                        textTransform: 'uppercase',
                        color: '#1a8a9a',
                        marginBottom: '10px',
                        fontWeight: '600'
                    }}>Why Choose Us</p>
                    <h2 style={{ borderLeft: 'none', paddingLeft: 0, textAlign: 'center', fontSize: '22px' }}>
                        A Trusted Partner at Every Step
                    </h2>
                    <p style={{ maxWidth: '700px', margin: '0 auto', textAlign: 'center', fontSize: '16px' }}>
                        Our strong network with global healthcare institutions, recruitment partners, and licensing
                        bodies enables us to deliver trusted and transparent services — guiding candidates through
                        eligibility assessment, exam preparation, visa processing, and job placement.
                    </p>
                </div>
            </div>

            {/* Certification */}
            <div className="section-wrap">
                <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                    <span className="cert-label">Official Document</span>
                    <h2 className="section-title">Our Certification</h2>
                    <p className="section-sub">Verified, registered, and recognized</p>
                </div>
                <div className="cert-box">
                    <img
                        src={certificationImage}
                        alt="Company Certification"
                        className="cert-img"
                        onError={(e) => {
                            e.target.style.display = 'none';
                            document.getElementById('cert-ph').style.display = 'flex';
                        }}
                    />
                    <div id="cert-ph" className="cert-placeholder" style={{ display: 'none' }}>
                        <div style={{ fontSize: '60px', marginBottom: '14px' }}>📜</div>
                        <p style={{ margin: 0, fontSize: '14px', color: '#94a3b8' }}>
                            Place your certificate at{' '}
                            <code style={{ background: '#f1f5f9', padding: '2px 8px', borderRadius: '4px', fontSize: '13px' }}>
                                public/assets/certification.jpg
                            </code>
                        </p>
                    </div>
                    <div className="cert-footer-bar">
                        Official Company Certification — Verified &amp; Registered
                    </div>
                </div>
            </div>

            <div style={{ height: '80px' }} />
        </div>
    );
};

export default About;